import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Edit, useDataProvider, useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import getLoadingState from '@/helpers/ui/getLoadingState.jsx';
import { ProductForm } from '@/components/product/forms/ProductForm.jsx';
import { StyledProductCreate } from '@/components/product/forms/ProductCreate.jsx';

export const ProductEdit = ({ handleClose, elementId }) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const [product, setProduct] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const loadingState = getLoadingState({ isLoading, error, data: product, translate });

    useEffect(() => {
        if (elementId) {
            setIsLoading(true);
            dataProvider
                .getOne('product', { id: elementId })
                .then(({ data }) => {
                    setProduct(data);
                    setError(null);
                })
                .catch(err => {
                    console.error('Error fetching product:', err);
                    setError(err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [dataProvider, elementId]);

    if (loadingState) return loadingState;

    return (
        <StyledProductCreate>
            <Box className='popup-wrapper popup-wrapper-top'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.product.labels.editProduct')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <Edit id={elementId} resource='product' mutationMode='pessimistic' redirect={false}>
                <Box className='padding-wrapper'>
                    <ProductForm handleClose={handleClose} isEdit={true} />
                </Box>
            </Edit>
        </StyledProductCreate>
    );
};

ProductEdit.propTypes = {
    handleClose: PropTypes.func,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
